// extracted by mini-css-extract-plugin
export default {"container":"SetupCampaignFooter_container__obvr3"};